import { gql } from "@apollo/client"

export const AGENT_LOGIN = gql`
  mutation agent_login($username: String!, $password: String!) {
    agent_login(username: $username, password: $password) {
      token
      me {
        id
        full_name
        agent {
          id
          name
          eid
          organisation {
            id
            codename
            uid
            name
          }
        }
      }
    }
  }
`
